// src/components/auth/LoginForm.tsx
import React, { useState } from 'react';
import { Form, Input, Button, Alert, Typography } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Link } = Typography;

interface LoginFormProps {
  onSwitchToSignup: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSwitchToSignup }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { signIn } = useAuth();

  const onFinish = async (values: any) => {
    setLoading(true);
    setError(null);
    try {
      const { error } = await signIn({ email: values.email, password: values.password });
      if (error) {
        // Map Firebase error codes to user-friendly messages
        let errorMessage = error.message;
        if (error.message.includes('auth/user-not-found')) {
          errorMessage = 'No account found with this email address.';
        } else if (error.message.includes('auth/wrong-password')) {
          errorMessage = 'Incorrect password.';
        } else if (error.message.includes('auth/invalid-email')) {
          errorMessage = 'Invalid email address.';
        } else if (error.message.includes('auth/too-many-requests')) {
          errorMessage = 'Too many failed login attempts. Please try again later.';
        }
        setError(errorMessage);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to login.');
    }
    setLoading(false);
  };

  return (
    <Form name="login" onFinish={onFinish} layout="vertical">
      <Form.Item
        name="email"
        rules={[{ required: true, type: 'email', message: 'Please input your Email!' }]}
      >
        <Input prefix={<MailOutlined />} placeholder="Email" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: 'Please input your Password!' }]}
      >
        <Input.Password prefix={<LockOutlined />} placeholder="Password" />
      </Form.Item>
      {error && <Alert message={error} type="error" showIcon closable style={{ marginBottom: '20px' }} />}
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} block>
          Login
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LoginForm;